import React, { useEffect, useState, useMemo } from "react";
import jsPDF from "jspdf";
// import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
import { Link, NavLink, useNavigate } from "react-router-dom";
import axios from "axios";

import DataTable from "react-data-table-component";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import config from "../../../../config/config";
import Loader from "../../../../components/Loader/Loader";
import DeleteConfirmationModal from "../../../../components/Modal/DeleteConfirmation";
import {
  DATA_EXPORT,
  DELETE_MESSAGE,
  ERROR_MESSAGE,
} from "../../../../common/Constant";
import { toastError, toastSuccess } from "../../../../common/Toast";
import CleanupConfirmationModal from "../../../../components/Modal/CleanupConfirmation";
import { Last } from "react-bootstrap/esm/PageItem";
import { checkUserPermission } from "../../../../common/UserPermission";
import Select from "react-select";
import * as XLSX from "xlsx";
import { Closed } from "../../../../common/imagePath";
import ItemsDetailsModal from "../../../../components/Modal/ItemsDetailsModal";

//MUI Table
import { MaterialReactTable } from "material-react-table";
import { MenuItem } from "@mui/material";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

// The below variable are for permission given to the Functionalities
let PERMISSION_ADD = "/manage-items";
let PERMISSION_EDIT = "/manage-items/:id";
let PERMISSION_DELETE = "delete-items";
let PERMISSION_VIEW = "view-items";
let PERMISSION_MANAGE_DELETED_ITEMS = "/deleted-items";
let PERMISSION_EXCEL_IMPORT = "/import-items";
let PERMISSION_EXCEL_EXPORT = "excel-export-items";
let PERMISSION_CLEANUP_OLD_ITEMS = "cleanup-old-items";
let PERMISSION_CUSTOM_FIELD_CONFIGURATION = "/items-custom-fields";
let PERMISSION_SHOW_COST_PRICE = "show-cost-price";

const Items = () => {
  let navigate = useNavigate();
  let selectData = [];
  let pathforpdf = "";
  let selectDatas = [];
  const token = localStorage.getItem("Token");
  const [perPageSize, setperPageSize] = useState(25);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [sortingId, setSortingId] = useState(6);
  const [state, setState] = useState("");
  const [sortingDirection, setSortingDirection] = useState("desc");
  const [searchtext, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const [selectedItemsCheckboxs, setselectedItemsCheckbox] = useState("");
  const [selectedItemsCheckEmails, setselectedItemsCheckEmails] = useState("");
  const [selectedItemsCheckpathforpdf, setselectedItemsCheckpathforpdf] =
    useState("");
  const [selectedItemsCheckClear, setselectedItemsCheckClear] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [hiddenColumns, setHiddenColumns] = useState([
    "Brand",
    "Barcodename",
    "ReplenishLevel",
    "ReorderLevel",
    "EndDate",
    "StartDate",
    "PromoPrice",
    "Tags",
    "ProductId",
    "Manufaturer",
    "Supplier",
  ]);

  const [field, setfield] = useState("all");

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const deleteRequestParam = localStorage.getItem("DeleteRequestParam");

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  const [showDateFilterModal, setShowDateFilterModal] = useState(false);

  //popup on delete
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const options = [
    { label: "All", value: 1 },
    { label: "Current Week", value: 4 },
    { label: "Last Week", value: 3 },
    { label: "Current Month", value: 6 },
    { label: "Last Month", value: 5 },
    { label: "Custom", value: 2 },
  ];

  const fieldOption = [
    { label: "All", value: "all" },
    { label: "Item Id", value: "ID" },
    { label: "UPC/EAN/ISBN", value: "Itemnumber" },
    { label: "Product ID", value: "ProductId" },
    { label: "Item Name", value: "Name" },
    { label: "Description", value: "Description" },
    { label: "Size", value: "Size" },
    { label: "Cost Price", value: "Costprice" },
    { label: "Selling Price", value: "Unitprice" },
    { label: "Promo Price", value: "Promoprice" },
    { label: "Reorder Level", value: "Reorderlevel" },
    { label: "Supplier", value: "CompanyName" },
    { label: "Manufacturer", value: "ManufactureName" },
    { label: "Tag", value: "TagsName" },
  ];

  const handleFieldChange = (event) => {
    console.log(event, "event1234");
    setfield(event?.value);
  };

  const [quickBookOptions, setQuickBookOptions] = useState({
    label: "All",
    value: 1,
  });

  console.log(quickBookOptions, "quickBookOptions");

  const [startingDate, setStartingDate] = useState("");
  const [endingDate, setEndingDate] = useState("");

  const [customStartingDate, setCustomStartingDate] = useState();
  const [customEndingDate, setCustomEndingDate] = useState("");
  const [showSearchBar, setShowSearchBar] = useState();
  const [itemsDetailsDataId, setItemsDetailsDataId] = useState();
  //categories state
  const [selectedCategory, setselectedCategory] = useState({ value: 0 });
  const [SecondCategories, setSecondCategories] = useState([]);

  let ParentCategoryOption = [];
  const ItemKits = data.map((u, i) => {
    ParentCategoryOption[i] = { label: u.Name, value: u.ID };
  });

  // Categories Option

  let Catagories = [];
  const ItemCategories = SecondCategories.map((u, i) => {
    Catagories[i] = { label: u.Name, value: u.ID };
  });

  //Categories Api

  const categoriesAPI = (CategorieData) => {
    //API
    axios
      .get(`${config.categoriesBaseUrl}/categories?filtertext=${""}`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        // setData(res.data.ResponseData);
        setSecondCategories(res.data.ResponseData);

        // if (CategorieData != undefined) {
        //   let CategorieList = res.data.ResponseData;
        //   CategorieList.map((selectedCategory) => {
        //     if (selectedCategory.ID == CategorieData) {
        //       setselectedCategory({
        //         label: selectedCategory.Name,
        //         value: selectedCategory.ID,
        //       });
        //     }
        //   });
        // }
      });
  };
  console.log(data, "data1234");

  // pdf make onclick
  const componentDidMount = () => {
    axios
      .get(
        `${config.itemsBaseUrl}/customers/customerdetailforlabel?id=${selectedItemsCheckboxs}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        this.setState({ data: res.data.ResponseData });
      });
  };

  // const handleRowSelected = (e) => {
  //   if (e.selectedRows.length > 0) {
  //     // for get detlais form id
  //     setSelectedRows(e.selectedRows.map((x) => x.ID));
  //     selectData[currentPage] = e.selectedRows.map((x) => x.ID);
  //     const selectedItemsCheckboxIDs =
  //       selectData.length > 0 ? selectData[currentPage].toString() : "";
  //     setselectedItemsCheckbox(selectedItemsCheckboxIDs);

  //     const datasplitforpath = selectedItemsCheckboxIDs?.split(",");
  //     pathforpdf = datasplitforpath?.join("~");
  //     setselectedItemsCheckpathforpdf(pathforpdf);

  //     // get emails of selectdids
  //     setSelectedRows(e.selectedRows.map((x) => x.Email));
  //     selectData[currentPage] = e.selectedRows.map((x) => x.Email);
  //     const selectedItemsCheckboxEmails =
  //       selectData.length > 0 ? selectData[currentPage].toString() : "";
  //     setselectedItemsCheckEmails(selectedItemsCheckboxEmails);
  //   }
  // };

  // const handleDeletePopup = (pID) => {

  //   const deleteRequestParam = {
  //     itemids: pID || selectedItemsCheckboxs,
  //   };
  //   localStorage.setItem(
  //     "DeleteRequestParam",
  //     JSON.stringify(deleteRequestParam)
  //   );
  //   setDeleteModalOpen(true)
  //   // setShowDateFilterModal(true)
  // };

  const handleDeletePopup = (id, rows, field) => {
    console.log(id, "id");
    // console.log(rows.map((el) => el.original), "rows231")
    let data;
    if (field === "multipleRowInactive") {
      data = rows.map((el) => el.original.ID).join(",");
    } else {
      data = id;
    }
    const deleteRequestParam = {
      itemids: data,
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
    // setShowDateFilterModal(true);
    // setShowAction(false);
    setDeleteModalOpen(true);
  };

  //Barcode Labels

  const handlebarcode = (id, rows, field) => {
    let data;
    if (field === "multipleRowInactive") {
      data = rows.map((el) => el.original.ID).join(",");
    }
    console.log(data, "data263");
    const barcodeRequestParam = {
      id: data,
    };
    localStorage.setItem(
      "BarcodeRequestParam",
      JSON.stringify(barcodeRequestParam)
    );
  };

  const handleClearSelected = () => {
    // setselectedItemsCheckClear(!selectedItemsCheckClear);
    setToggleCleared(!toggleCleared);
  };

  const contextActions = useMemo(() => {
    // for handling barcode label
    const handlebarcode = (pID) => {
      const barcodeRequestParam = pID;
      localStorage.setItem("BarcodeRequestParam", barcodeRequestParam);
    };

    const handlepdf = () => {
      axios
        .get(
          `${config.itemsBaseUrl}/customers/customerdetailforlabel?id=${selectedItemsCheckboxs}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          const doc = new jsPDF();

          let position = 0;
          for (let i = 0; i < res.data.ResponseData.length; i++) {
            position = position + 10;
            doc.setFontSize(10);
            doc.text(
              `UPC/EAN/ISBN: ${res.data.ResponseData[i].Name}`,
              10,
              position
            );
            position = position + 10;
            doc.text(
              `LastName: ${res.data.ResponseData[i].LastName}`,
              10,
              position
            );
            position = position + 10;
            doc.text(`Email: ${res.data.ResponseData[i].Email}`, 10, position);
            position = position + 10;
            doc.text(`City: ${res.data.ResponseData[i].City}`, 10, position);
            position = position + 10;
            doc.text(
              `Address1: ${res.data.ResponseData[i].Address1}`,
              10,
              position
            );

            position = position + 10;

            if (i % 4 == 0 && i >= 4) {
              doc.addPage();
              position = 0;
            }
          }
          //   doc.deletePage(Last);
          doc.save(`${selectedItemsCheckpathforpdf}.pdf`);
          setState({ data: res.data.ResponseData });
        });
    };

    return (
      <>
        <div className="row mr-1">
          <div className="col-12 align-self-center">
            <button
              type="button"
              className="btn btn-dark btn-sm btn-custom-padding"
              onClick={handleClearSelected}
            >
              <i className="fa fa-times"></i> Clear
            </button>
          </div>
        </div>

        <div className="row mr-1">
          {/* <div className="col-12 align-self-center">
            <a href={"/customer-barcode-label"}>
              <button
                type="button"
                className="btn btn-dark btn-sm btn-custom-padding"
                onClick={handlebarcode(selectedItemsCheckboxs)}
              >
                <i className="fa fa-envelope-square fa-sm" /> Barcode Labels
              </button>
            </a>
          </div> */}
        </div>

        <div className="row mr-1">
          <div className="col-12 align-self-center">
            <button
              type="button"
              className="btn btn-danger btn-sm btn-custom-padding pull-left "
              data-bs-toggle="modal"
              data-bs-target="#DeleteConfirmationModal"
              onClick={() => handleDeletePopup()}
            >
              <i className="fa fa-trash fa-sm" /> Delete Selected
            </button>
          </div>
        </div>
      </>
    );
  }, [data, selectedRows, toggleCleared]);

  const formatDate = (string) => {
    var options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(string).toLocaleDateString([], options);
  };

  // useEffect(() => {
  //   if (quickBookOptions.value !== 2) {
  //     handleListData(
  //       currentPage,
  //       perPageSize,
  //       searchtext,
  //       sortingId,
  //       sortingDirection,
  //       startingDate,
  //       endingDate
  //     );
  //   }
  // }, [
  //   currentPage,
  //   perPageSize,
  //   searchtext,
  //   sortingId,
  //   sortingDirection,
  //   startingDate,
  //   // endingDate,
  // ]);

  useEffect(() => {
    categoriesAPI();
    // if (quickBookOptions.value !== 2) {
    //   handleListData(
    //     currentPage,
    //     perPageSize,
    //     searchtext,
    //     sortingId,
    //     sortingDirection,
    //     startingDate,
    //     endingDate,
    //     selectedCategory,
    //     field
    //   );
    // }
  }, []);

  // Styles
  const selectStyles = {
    // dropdown input css
    control: (provided, state) => ({
      ...provided,
      width: "100%",
      height: "40px",
      position: "relative",
      border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
      "&:hover": {
        border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      },
    }),
    // dropdown menu css
    menu: () => ({
      boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
      position: "absolute",
      "z-index": "999",
      background: "#f8f8f8",
      width: "100%",
    }),
    // dropdown option css
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
      "&:hover": {
        backgroundColor: "rgba(255, 149, 0, 0.1)", // change hover color to light orange
      },
    }),
  };

  const handleItemsDetailsData = (id) => {
    //  api call
    setItemsDetailsDataId(id);
  };

  // Table Data
  // const columns = [
  //   // {
  //   //   name: "No",
  //   //   selector: (row) => row["RowNumber"],
  //   //   width: "60px",
  //   // },
  //   {
  //     name: "Action",
  //     cell: (row) => (
  //       <>
  //         {/* {
  //           checkUserPermission(PERMISSION_EDIT) ? (
  //             <Link
  //               className="me-3"
  //               type="button"
  //               onClick={(e) => handleItemsDetailsData(row.ID)}
  //               data-bs-target="#ItemsDetailsModal"
  //               data-bs-toggle="modal"
  //               style={{
  //                 display: "flex",
  //                 alignItems: "center",
  //               }}
  //             >
  //               <i class="fa fa-eye fa-2x" aria-hidden="true" title="View"></i>
  //             </Link>
  //           ) : (
  //             ""
  //           )}
  //         {checkUserPermission(PERMISSION_EDIT) ? (
  //           <Link className="me-3" to={`/manage-Items/${row.ID}`}>
  //             <i className="fa fa-edit text-warning fa-2x" title="Edit"></i>
  //           </Link>
  //         ) : (
  //           ""
  //         )}

  //         {checkUserPermission(PERMISSION_DELETE) ? (
  //           <Link
  //             className="confirm-text"
  //             to="#"
  //             title="Delete"
  //             data-bs-toggle="modal"
  //             data-bs-target="#DeleteConfirmationModal"
  //             onClick={() => handleDeletePopup(row.ID)}
  //           >
  //             <i
  //               className="fa fa-trash text-red fa-2x"
  //               data-bs-toggle="tooltip"
  //               title="Delete"
  //             ></i>
  //           </Link>
  //         ) : (
  //           ""
  //         )} */}

  //         <div class="btn-group-sm" role="group" >
  //           {
  //             checkUserPermission(PERMISSION_EDIT) ? (
  //               <Link className="btn btn-primary btn-sm btn-custom-padding"
  //                 to={`/manage-Items/${row.ID}`}
  //                 style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
  //               >
  //                 Edit
  //               </Link>
  //             ) : ""
  //           }

  //           <button
  //             type="button"
  //             className="btn btn-outline-primary btn-sm dropdown-toggle btn-custom-padding"
  //             data-bs-toggle="dropdown"
  //             aria-haspopup="true"
  //             aria-expanded="false"
  //             style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
  //           >
  //           </button>
  //           <div className="dropdown-menu">
  //             {
  //               checkUserPermission(PERMISSION_EDIT) ? (
  //                 <li>
  //                   <Link
  //                     className="dropdown-item me-3"
  //                     type="button"
  //                     onClick={(e) => handleItemsDetailsData(row.ID)}
  //                     data-bs-target="#ItemsDetailsModal"
  //                     data-bs-toggle="modal"
  //                     style={{
  //                       display: "flex",
  //                       alignItems: "center",
  //                     }}
  //                   >
  //                     <i class="fa fa-eye " aria-hidden="true" title="View"></i>&nbsp;View Item
  //                   </Link>
  //                 </li>
  //               ) : (
  //                 ""
  //               )}

  //             {/* {checkUserPermission(PERMISSION_EDIT) ? (
  //               <li>
  //                 <Link className="dropdown-item me-3" to={`/manage-Items/${row.ID}`}>
  //                   <i className="fa fa-edit" title="Edit"></i>&nbsp;Edit Item
  //                 </Link>
  //               </li>
  //             ) : (
  //               ""
  //             )} */}

  //             {checkUserPermission(PERMISSION_DELETE) ? (
  //               <li>
  //                 <Link
  //                   className="dropdown-item confirm-text"
  //                   to="#"
  //                   title="Delete"
  //                   data-bs-toggle="modal"
  //                   data-bs-target="#DeleteConfirmationModal"
  //                   onClick={() => handleDeletePopup(row.ID)}
  //                 >
  //                   <i
  //                     className="fa fa-trash"
  //                     data-bs-toggle="tooltip"
  //                     title="Delete"
  //                   ></i>&nbsp;Delete Item
  //                 </Link>
  //               </li>
  //             ) : (
  //               ""
  //             )}
  //           </div>
  //         </div>
  //       </>
  //     ),
  //     ignoreRowClick: true,
  //     allowOverflow: true,
  //     button: true,
  //     minWidth: "70px",
  //     width: "70px",
  //   },
  //   {
  //     name: "Item Id",
  //     selector: (row) => (
  //       <>
  //         {row.VariationId > 0 ? row.ID + "#" + row.VariationId : row.ID}
  //       </>
  //     ),
  //     minWidth: "110px",
  //     width: "110px",
  //   },
  //   {
  //     name: "UPC/EAN/ISBN",
  //     selector: (row) => row["Itemnumber"],
  //     sortable: true,
  //     minWidth: "150px",
  //     width: "150px",
  //   },
  //   {
  //     name: "Name",
  //     selector: (row) => (
  //       <Link
  //         type="button"
  //         onClick={(e) => handleItemsDetailsData(row.ID)}
  //         data-bs-target="#ItemsDetailsModal"
  //         data-bs-toggle="modal"
  //         style={{ color: "#000" }}
  //       >
  //         <div className="word-break-data" title={row.Name}>
  //           {!row.VariationId && <i className="fa fa-list-ul"></i>} {row.Name}
  //         </div>
  //       </Link>
  //     ),
  //     sortable: true,
  //     minWidth: "120px",
  //     // width: "180px",
  //   },
  //   {
  //     name: "Category",
  //     // selector: (row) => row["Categoryfullpath"],
  //     selector: (row) => (
  //       <p className="word-break-data" title={row.Categoryfullpath}>
  //         {row.Categoryfullpath}
  //       </p>
  //     ),
  //     sortable: true,
  //     minWidth: "105px",
  //     //width: "120px",
  //   },
  //   {
  //     name: "Cost Price",
  //     selector: (row) =>
  //       parseFloat(row.Costprice !== null ? row.Costprice : 0).toFixed(2),
  //     sortable: true,
  //     right: true,
  //     minWidth: "110px",
  //     width: "110px",
  //   },
  //   {
  //     name: "Sell Price",
  //     selector: (row) =>
  //       parseFloat(row.Unitprice != null ? row.Unitprice : 0).toFixed(2),
  //     sortable: true,
  //     right: true,
  //     minWidth: "110px",
  //     width: "110px",
  //   },
  //   {
  //     name: "Qty.",
  //     // selector: "parseFloat(Quantity).toFixed(2)",
  //     selector: (row) =>
  //       parseFloat(row.Quantity !== null ? row.Quantity : 0).toFixed(2),
  //     sortable: true,
  //     right: true,
  //     minWidth: "100px",
  //     width: "100px",
  //   },
  //   {
  //     name: "Images",
  //     selector: (row) => row["ImageURL"],
  //     minWidth: "80px",
  //     width: "80px",
  //     center: true,
  //     cell: (row) => (
  //       <>
  //         {
  //           row.ImageURL ? (<a target="_blank" href={row.ImageURL}>
  //             <img
  //               src={
  //                 row.ImageURL
  //                   ? row.ImageURL
  //                   : "https://www.freeiconspng.com/uploads/no-image-icon-4.png"
  //               }
  //               style={{ maxWidth: "25px", maxHeight: "25px", margin: "2px" }}
  //             />
  //           </a>)
  //             :
  //             (<img
  //               src={
  //                 row.ImageURL
  //                   ? row.ImageURL
  //                   : "https://www.freeiconspng.com/uploads/no-image-icon-4.png"
  //               }
  //               style={{ maxWidth: "25px", maxHeight: "25px", margin: "2px" }}
  //             />)
  //         }
  //       </>
  //     ),
  //   },
  //   {
  //     name: "Supplier",
  //     selector: (row) => (
  //       <p className="word-break-data" title={row.Supplier}>
  //         {row.Supplier != null ? row.Supplier : ""}
  //       </p>
  //     ),
  //     sortable: true,
  //     //width: "12%"
  //     minWidth: "105px",
  //     //width: "150px",
  //   },
  //   {
  //     name: "Manufaturer",
  //     selector: (row) => (
  //       <p className="word-break-data" title={row.Manufaturer}>
  //         {row.Manufaturer}
  //       </p>
  //     ),
  //     sortable: true,
  //     //width: "12%"
  //     minWidth: "140px",
  //     //width: "150px",
  //   },
  //   {
  //     name: "Product Id",
  //     selector: (row) => (
  //       <p className="word-break-data" title={row.ProductId}>
  //         {row.ProductId}
  //       </p>
  //     ),
  //     sortable: true,
  //     //width: "12%"
  //     minWidth: "120px",
  //     //width: "150px",
  //   },
  //   {
  //     name: "Tags",
  //     selector: (row) => (
  //       <p className="word-break-data" title={row.Tags}>
  //         {row.Tags}
  //       </p>
  //     ),
  //     sortable: true,
  //     //width: "11%"
  //     minWidth: "105px",
  //     //width: "150px",
  //   },
  //   {
  //     name: "Promo Price",
  //     selector: (row) =>
  //       parseFloat(row.PromoPrice !== null ? row.PromoPrice : 0).toFixed(2),
  //     sortable: true,
  //     right: true,
  //     //width: "11%"
  //     minWidth: "140px",
  //     //width: "150px",
  //   },
  //   {
  //     name: "Start Date",
  //     selector: (row) => (
  //       <p className="word-break-data">
  //         {row.Startdate}
  //       </p>
  //     ),
  //     sortable: true,
  //     //width: "11%"
  //     minWidth: "140px",
  //     //width: "100px",
  //   },
  //   {
  //     name: "End Date",
  //     selector: (row) => (
  //       <p className="word-break-data">
  //         {row.Enddate}
  //       </p>
  //     ),
  //     sortable: true,
  //     // width: "11%"
  //     minWidth: "140px",
  //     //width: "120px",
  //   },
  //   {
  //     name: "Reorder Level",
  //     selector: (row) => (
  //       <p className="word-break-data">
  //         {row.ReorderLevel}
  //       </p>
  //     ),
  //     sortable: true,
  //     //width: "11%"
  //     minWidth: "140px",
  //   },
  //   {
  //     name: "Replenish Level",
  //     selector: (row) => (
  //       <p className="word-break-data">
  //         {row.ReplenishLevel}
  //       </p>
  //     ),
  //     sortable: true,
  //     //width: "11%"
  //     minWidth: "150px",
  //     // width: "150px",
  //   },
  //   {
  //     name: "Barcode name",
  //     selector: (row) => (
  //       <p className="word-break-data">
  //         {row.Barcodename}
  //       </p>
  //     ),
  //     sortable: true,
  //     // width: "11%"
  //     minWidth: "140px",
  //     //width: "150px",
  //   },
  //   {
  //     name: "Brand",
  //     selector: (row) => (
  //       <p className="word-break-data">
  //         {row.Brand}
  //       </p>
  //     ),
  //     sortable: true,
  //     //width: "11%"
  //     minWidth: "140px",
  //     //width: "150px",
  //   },
  // ];

  const columns = useMemo(() => [
    {
      header: "Item Id",
      accessorKey: "ID",
      Cell: ({ row }) => (
        <>
          {/* {
            checkUserPermission(PERMISSION_EDIT) ? (
              <Link
                className="me-3"
                type="button"
                onClick={(e) => handleItemsDetailsData(row.ID)}
                data-bs-target="#ItemsDetailsModal"
                data-bs-toggle="modal"
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <i class="fa fa-eye fa-2x" aria-hidden="true" title="View"></i>
              </Link>
            ) : (
              ""
            )}
          {checkUserPermission(PERMISSION_EDIT) ? (
            <Link className="me-3" to={`/manage-Items/${row.ID}`}>
              <i className="fa fa-edit text-warning fa-2x" title="Edit"></i>
            </Link>
          ) : (
            ""
          )}

          {checkUserPermission(PERMISSION_DELETE) ? (
            <Link
              className="confirm-text"
              to="#"
              title="Delete"
              data-bs-toggle="modal"
              data-bs-target="#DeleteConfirmationModal"
              onClick={() => handleDeletePopup(row.ID)}
            >
              <i
                className="fa fa-trash text-red fa-2x"
                data-bs-toggle="tooltip"
                title="Delete"
              ></i>
            </Link>
          ) : (
            ""
          )} */}

          {/* <div class="btn-group-sm" role="group" >
            {
              checkUserPermission(PERMISSION_EDIT) ? (
                <Link className="btn btn-primary btn-sm btn-custom-padding"
                  to={`/manage-Items/${row.ID}`}
                  style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                >
                  Edit
                </Link>
              ) : ""
            }

            <button
              type="button"
              className="btn btn-outline-primary btn-sm dropdown-toggle btn-custom-padding"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
            >
            </button>
            <div className="dropdown-menu">
              {
                checkUserPermission(PERMISSION_VIEW) ? (
                  <li>
                    <Link
                      className="dropdown-item me-3"
                      type="button"
                      onClick={(e) => handleItemsDetailsData(row.ID)}
                      data-bs-target="#ItemsDetailsModal"
                      data-bs-toggle="modal"
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <i class="fa fa-eye " aria-hidden="true" title="View"></i>&nbsp;View Item
                    </Link>
                  </li>
                ) : (
                  ""
                )}

              {/* {checkUserPermission(PERMISSION_EDIT) ? (
                <li>
                  <Link className="dropdown-item me-3" to={`/manage-Items/${row.ID}`}>
                    <i className="fa fa-edit" title="Edit"></i>&nbsp;Edit Item
                  </Link>
                </li>
              ) : (
                ""
              )} */}

          {/* {checkUserPermission(PERMISSION_DELETE) ? (
                <li>
                  <Link
                    className="dropdown-item confirm-text"
                    to="#"
                    title="Delete"
                    data-bs-toggle="modal"
                    data-bs-target="#DeleteConfirmationModal"
                    onClick={() => handleDeletePopup(row.ID)}
                  >
                    <i
                      className="fa fa-trash"
                      data-bs-toggle="tooltip"
                      title="Delete"
                    ></i>&nbsp;Delete Item
                  </Link>
                </li>
              ) : (
                ""
              )}
            </div>
          </div> */}
          {row.original.VariationId > 0
            ? row.original.ID + "#" + row.original.VariationId
            : row.original.ID}
        </>
      ),
    },
    {
      header: "UPC/EAN/ISBN",
      accessorKey: "Itemnumber",
    },
    // {
    //   name: "UPC/EAN/ ISBN",
    //   selector: (row) => row["Itemnumber"],
    //   sortable: true,
    //   minWidth: "150px",
    //   width: "150px",
    // },
    {
      // name: "Name",
      // selector: (row) => (
      //   checkUserPermission(PERMISSION_VIEW) ? (
      //     <Link
      //       type="button"
      //       onClick={(e) => handleItemsDetailsData(row.ID)}
      //       data-bs-target="#ItemsDetailsModal"
      //       data-bs-toggle="modal"
      //       style={{ color: "#000" }}
      //     >
      //       <div className="word-break-data" title={row.Name}>
      //         {!row.VariationId && <i className="fa fa-list-ul"></i>} {row.Name}
      //       </div>
      //     </Link>
      //   ) :
      //     <div className="word-break-data" title={row.Name}>
      //       {!row.VariationId && <i className="fa fa-list-ul"></i>} {row.Name}

      //       </div>
      // )
      header: "Name",
      accessorKey: "Name",
      Cell: ({ row }) => (
        <Link
          type="button"
          onClick={(e) => handleItemsDetailsData(row.original.ID)}
          data-bs-target="#ItemsDetailsModal"
          data-bs-toggle="modal"
          style={{ color: "#000" }}
        >
          <div className="word-break-data" title={row.original.Name}>
            {!row.original.VariationId && <i className="fa fa-list-ul"></i>}{" "}
            {row.original.Name}
          </div>
        </Link>
      ),
    },
    {
      header: "Category",
      accessorKey: "Categoryfullpath",
      Cell: ({ row }) => (
        <p className="word-break-data" title={row?.original?.Categoryfullpath}>
          {row?.original?.Categoryfullpath}
        </p>
      ),
    },
    checkUserPermission("show-cost-price") && {
      header: "Cost Price",
      accessorKey: "Costprice",
      Cell: ({ row }) =>
        parseFloat(
          row?.original?.Costprice !== null ? row?.original?.Costprice : 0
        ).toFixed(2),
    },
    {
      header: "Sell Price",
      accessorKey: "Unitprice",
      Cell: ({ row }) =>
        parseFloat(
          row?.original?.Unitprice != null ? row?.original?.Unitprice : 0
        ).toFixed(2),
    },
    {
      header: "Qty.",
      accessorKey: "Quantity",
      Cell: ({ row }) =>
        parseFloat(
          row.original.Quantity !== null ? row.original.Quantity : 0
        ).toFixed(2),
    },
    {
      header: "Images",
      Cell: ({ row }) => (
        <>
          {row.original.ImageURL ? (
            <a target="_blank" href={row.original.ImageURL}>
              <img
                src={
                  row.original.ImageURL
                    ? row.original.ImageURL
                    : "https://www.freeiconspng.com/uploads/no-image-icon-4.png"
                }
                style={{ maxWidth: "25px", maxHeight: "25px", margin: "2px" }}
              />
            </a>
          ) : (
            <img
              src={
                row.original.ImageURL
                  ? row.original.ImageURL
                  : "https://www.freeiconspng.com/uploads/no-image-icon-4.png"
              }
              style={{ maxWidth: "25px", maxHeight: "25px", margin: "2px" }}
            />
          )}
        </>
      ),
    },
    {
      header: "Supplier",
      accessorKey: "Supplier",
      Cell: ({ row }) => (
        <p className="word-break-data" title={row.original.Supplier}>
          {row.original.Supplier != null ? row.original.Supplier : ""}
        </p>
      ),
    },
    {
      header: "Manufacturer",
      accessorKey: "Manufaturer",
      Cell: ({ row }) => (
        <p className="word-break-data" title={row.original.Manufaturer}>
          {row.original.Manufaturer}
        </p>
      ),
    },
    {
      header: "Product Id",
      accessorKey: "ProductId",
      Cell: ({ row }) => (
        <p className="word-break-data" title={row.original.ProductId}>
          {row.original.ProductId}
        </p>
      ),
    },
    {
      header: "Tags",
      accessorKey: "Tags",
      Cell: ({ row }) => (
        <p className="word-break-data" title={row.original.Tags}>
          {row.original.Tags}
        </p>
      ),
    },
    {
      header: "Promo Price",
      accessorKey: "PromoPrice",
      Cell: ({ row }) =>
        parseFloat(
          row.original.PromoPrice !== null ? row.original.PromoPrice : 0
        ).toFixed(2),
    },
    {
      header: "Start Date",
      accessorKey: "Startdate",
      Cell: ({ row }) => (
        <p className="word-break-data">{row.original.Startdate}</p>
      ),
    },
    {
      header: "End Date",
      accessorKey: "Enddate",
      Cell: ({ row }) => (
        <p className="word-break-data">{row.original.Enddate}</p>
      ),
    },
    {
      header: "Reorder Level",
      accessorKey: "ReorderLevel",
      Cell: ({ row }) => <p className="word-break-data">{row.ReorderLevel}</p>,
    },
    {
      header: "Replenish Level",
      accessorKey: "ReplenishLevel",
      Cell: ({ row }) => (
        <p className="word-break-data">{row.original.ReplenishLevel}</p>
      ),
    },
    {
      header: "Barcode name",
      accessorKey: "Barcodename",
      Cell: ({ row }) => (
        <p className="word-break-data">{row.original.Barcodename}</p>
      ),
    },
    {
      header: "Brand",
      accessorKey: "Brand",
      Cell: ({ row }) => (
        <p className="word-break-data">{row.original.Brand}</p>
      ),
    },
  ]);

  // const handleSelectedRowsChange = (e) => {
  //     if (e.selectedRows.length > 0) {
  //         setSelectedData(e.selectedRows.map(x => x.ID));
  //         selectData[currentPage] = e.selectedRows.map(x => x.ID);
  //     }
  // }

  function handleCheckboxChange(columnName) {
    console.log("columnName ==>", columnName);
    if (hiddenColumns.includes(columnName)) {
      setHiddenColumns(hiddenColumns.filter((column) => column !== columnName));
    } else {
      setHiddenColumns([...hiddenColumns, columnName]);
    }
  }
  console.log(hiddenColumns, "hiddenColumns810");

  const handlePerRowsChange = async (page, newPerPage) => {
    setperPageSize(newPerPage);
    setCurrentPage(page);
    handleListData(
      page,
      newPerPage,
      searchtext,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate,
      selectedCategory?.value,
      field
    );
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    handleListData(
      page,
      perPageSize,
      searchtext,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate,
      selectedCategory?.value,
      field
    );
  };

  const handleSort = (e, sortingDirection) => {
    setSortingId(e.id);
    setSortingDirection(sortingDirection);
    handleListData(
      1,
      perPageSize,
      searchtext,
      e.id,
      sortingDirection,
      startingDate,
      endingDate,
      selectedCategory?.value,
      field
    );
  };

  const ChangeFilterText = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
    // handleListData(1, perPageSize, e.target.value, sortingId, sortingDirection,startingDate,endingDate);
  };

  useEffect(() => {
    // fetchData();

    // const timer = setTimeout(() => {
    //   // Make your API call here
    fetchData();
    // }, 500); // Adjust the delay according to your needs (in milliseconds)

    // return () => {
    //   clearTimeout(timer);
    // };
  }, [columnFilters, globalFilter, pagination, sorting, selectedCategory]);

  // Fetch data from an API
  const fetchData = async () => {
    console.log("call => ", searchtext);
    handleListData(
      1,
      perPageSize,
      searchtext,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate,
      selectedCategory?.value,
      field,
      columnFilters,
      globalFilter,
      pagination,
      sorting
    );
  };

  const handleExcelExport = () => {
    setLoading(true);
    axios
      .post(
        `${config.itemsBaseUrl}/items/exportexcel`,
        {
          filtertext: searchtext,
          ordercolumn: sortingId,
          currentorder: sortingDirection,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        let data;
        checkUserPermission("show-cost-price")
          ? (data =
              res.data.ResponseData.length > 0 ? res.data.ResponseData : [])
          : (data =
              res.data.ResponseData.length > 0
                ? res.data.ResponseData.map((item) => {
                    const { Costprice, ...rest } = item;
                    return rest;
                  })
                : []);

        // Create a new workbook
        const workbook = XLSX.utils.book_new();

        // Convert the data to a worksheet
        const worksheet = XLSX.utils.json_to_sheet(data);

        // Add the worksheet to the workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        // Save the workbook as an Excel file
        XLSX.writeFile(workbook, `items_details_.xlsx`);
        setLoading(false);
      })
      .catch((err) => {
        toastError(ERROR_MESSAGE);
        setLoading(false);
      });
  };

  console.log("hiddenColumns => ", hiddenColumns);
  // generate new columns according to hiddenColumns data and pass it as datatable column
  // const filteredColumns = columns?.filter(
  //   (column) => !hiddenColumns.includes(column.name.replace(/\s+|-|\/|#/g, ""))
  // );

  // console.log(filteredColumns, "filteredColumns")

  const handleChangeCustomStartingDate = (event) => {
    if (event.target.value !== undefined) {
      setCustomStartingDate(event.target.value);
      setStartingDate(event.target.value);
    }
  };

  const handleChangeCustomEndingDate = (event) => {
    setCustomEndingDate(event.target.value);
    setEndingDate(event.target.value);
  };

  const handleCategoryChanged = (event) => {
    console.log("Event  ==>", event);
    // setselectedCategory(event.value);
    let categoryID = 0;
    if (event != null) {
      setselectedCategory(event);
      categoryID = event.value;
    } else {
      setselectedCategory({ name: "", value: 0 });
    }
    handleListData(
      1,
      perPageSize,
      searchtext,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate,
      categoryID,
      field
    );
  };

  // Get all tag data
  const handleListData = (
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorder,
    startingdate,
    endingdate,
    categoryid,
    fieldname,
    columnFilters,
    globalFilter,
    pagination,
    sorting
  ) => {
    setLoading(true);

    console.log(sorting, "sorting");
    console.log(categoryid, "categoryid");
    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters;

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    const columnIndex = columns.findIndex((column) =>
      column.accessorKey === sorting.length > 0 ? sorting[0]?.id : ""
    );
    axios
      .get(
        `${
          config.itemsBaseUrl
        }/items?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagenumber=${
          pagination.pageIndex + 1
        }&pagesize=${pagination.pageSize}&filtertext=${
          globalFilter == undefined ? "" : globalFilter
        }&startdate=${startingdate}&enddate=${endingdate}&categoryid=${
          categoryid === undefined ? 0 : categoryid
        }&fieldname=${field}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setData(res.data.ResponseData);
        setTotalRows(res.data.ResponseData[0]?.TotalRecord);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  //Search

  // const handleSearch = () =>{
  //   // console.log("Bhaskar Joshi")
  // }

  const handleSearchAccordingToDate = () => {
    handleListData(
      1,
      perPageSize,
      searchtext,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate
    );
  };

  const handleQuickBookChange = (fieldName, event) => {
    setShowSearchBar(event.value);
    setQuickBookOptions(event);

    // All Condition
    if (event?.value == 1) {
      setStartingDate("");
      setEndingDate("");
    }
    // Custom Condition
    else if (event?.value == 2) {
      setStartingDate(customStartingDate);
      setEndingDate(customEndingDate);
    }
    // Last Week Condition
    else if (event?.value == 3) {
      var currentDateForLastWeek = new Date();
      // Set the date to the start of the current week (Sunday)
      var startOfWeekForLastWeek = new Date(
        currentDateForLastWeek.setDate(
          currentDateForLastWeek.getDate() - currentDateForLastWeek.getDay()
        )
      );

      // Set the date to the end of the last week (Saturday)
      var endOfLastWeekForLastWeek = new Date(
        startOfWeekForLastWeek.setDate(startOfWeekForLastWeek.getDate() - 1)
      );

      // Set the date to the start of the last week (Sunday)
      var startOfLastWeekForLastWeek = new Date(
        startOfWeekForLastWeek.setDate(endOfLastWeekForLastWeek.getDate() - 6)
      );

      // Format the dates as strings in the YYYY-MM-DD format
      var startDateStringForLastWeek = startOfLastWeekForLastWeek
        .toISOString()
        .slice(0, 10);
      var endDateStringForLastWeek = endOfLastWeekForLastWeek
        .toISOString()
        .slice(0, 10);
      // Output the results

      setStartingDate(startDateStringForLastWeek);
      setEndingDate(endDateStringForLastWeek);
    }
    // Current Week Condition
    else if (event?.value == 4) {
      var currentDateForCurrentWeek = new Date();
      // Set the date to the start of the current week (Sunday)
      var startOfWeekForCurrentWeek = new Date(
        currentDateForCurrentWeek.getTime() -
          currentDateForCurrentWeek.getDay() * 24 * 60 * 60 * 1000
      );

      // Set the date to the end of the current week (Saturday)
      var endOfWeekForCurrentWeek = new Date(
        startOfWeekForCurrentWeek.getTime() + 6 * 24 * 60 * 60 * 1000
      );

      // Format the dates as strings in the YYYY-MM-DD format
      var startDateStringForCurrentWeek = startOfWeekForCurrentWeek
        .toISOString()
        .slice(0, 10);

      var endDateStringForCurrentWeek = endOfWeekForCurrentWeek
        .toISOString()
        .slice(0, 10);

      setStartingDate(startDateStringForCurrentWeek);
      setEndingDate(endDateStringForCurrentWeek);
    }
    // Last Month Condition
    else if (event?.value == 5) {
      // Get today's date
      const todayForLastMonth = new Date();

      // Get the first day of the current month
      const firstDayCurrentMonthForLastMonth = new Date(
        todayForLastMonth.getFullYear(),
        todayForLastMonth.getMonth(),
        1
      );

      // Get the last day of the previous month
      const lastDayPrevMonthForLastMonth = new Date(
        firstDayCurrentMonthForLastMonth.getTime() - 1
      );

      // Get the starting date of the previous month
      const firstDayPrevMonthForLastMonth = new Date(
        lastDayPrevMonthForLastMonth.getFullYear(),
        lastDayPrevMonthForLastMonth.getMonth(),
        1
      );

      // Format the starting and ending dates of the previous month as yyyy-mm-dd
      const startDateFormattedForLastMonth = firstDayPrevMonthForLastMonth
        .toISOString()
        .slice(0, 10);
      const endDateFormattedForLastMonth = lastDayPrevMonthForLastMonth
        .toISOString()
        .slice(0, 10);

      setStartingDate(startDateFormattedForLastMonth);
      setEndingDate(endDateFormattedForLastMonth);
    }
    // Current Month Condition
    else if (event?.value == 6) {
      // Get today's date
      const todayForCurrentMonth = new Date();

      // Get the first day of the current month
      const firstDayOfMonthForCurrentMonth = new Date(
        todayForCurrentMonth.getFullYear(),
        todayForCurrentMonth.getMonth(),
        1
      );

      // Get the last day of the current month
      const lastDayOfMonthForCurrentMonth = new Date(
        todayForCurrentMonth.getFullYear(),
        todayForCurrentMonth.getMonth() + 1,
        0
      );

      // Format the starting and ending dates of the current month as yyyy-mm-dd
      const startDateFormattedForCurrentMonth = firstDayOfMonthForCurrentMonth
        .toISOString()
        .slice(0, 10);
      const endDateFormattedForCurrentMonth = lastDayOfMonthForCurrentMonth
        .toISOString()
        .slice(0, 10);
      setStartingDate(startDateFormattedForCurrentMonth);
      setEndingDate(endDateFormattedForCurrentMonth);
    }
  };

  const handleQuickBookDownload = () => {
    if (
      startingDate === undefined ||
      (endingDate === undefined && quickBookOptions.value == 1)
    ) {
      setStartingDate("");
      setEndingDate("");
    }
    // else if (
    //   startingDate === undefined ||
    //   (endingDate === undefined && quickBookOptions.value == 2)
    // ) {
    //   // console.log("Undefined dates");
    // }
    else {
      axios
        .get(
          `${
            config.itemsBaseUrl
          }/items/exportexcellisting?filtertext=${""}&startdate=${startingDate}&enddate=${endingDate}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          const data =
            res.data.ResponseData.length > 0
              ? res.data.ResponseData
              : [
                  {
                    [`ID`]: null,
                    [`Created Date`]: null,
                    [`Description`]: null,
                    [`Item Number`]: null,
                    [`Name`]: null,
                    [`Unit Price`]: null,
                  },
                ];

          // Create a new workbook
          const workbook = XLSX.utils.book_new();

          // Convert the data to a worksheet
          const worksheet = XLSX.utils.json_to_sheet(data);

          // Add the worksheet to the workbook
          XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

          // Save the workbook as an Excel file
          XLSX.writeFile(
            workbook,
            `items_quickbook_${startingDate}_${endingDate}.xlsx`
          );
          setLoading(false);
        })
        .catch((err) => {
          toastError(ERROR_MESSAGE);
          setLoading(false);
        });
    }
  };

  // Pdf Print
  const handlePrint = (rows, field) => {
    setLoading(true);

    let newData = [];
    if (field === "selectedrow") {
      newData = rows.map((row) => row.original);
    } else if (field === "alldata") {
      newData = data;
    }

    var doc = new jsPDF("p", "pt", "a4");

    let content = "";
    let startIndex = 0;
    let endIndex = 25;

    for (var i = 1; i <= Math.ceil(newData.length / 26); i++) {
      // Printing header
      if (i === 1) {
        content +=
          '<div style="width: 560px; margin: 1rem">' +
          '<p style="text-align:right; font-size: 7px;">' +
          i +
          " / " +
          Math.ceil(newData.length / 26) +
          "</p>" +
          '<p style="text-align:center; font-weight: bold; font-size: 1.2rem; margin: 0; margin-top: -1rem">' +
          "Sonar Pos" +
          "</p>" +
          '<p style="text-align:center; margin: 0; font-size: 10px">' +
          "Items List" +
          "</p>" +
          "</div>";
      }
      if (i > 1) {
        content +=
          '<div style="width: 560px; margin: 1rem; margin-top: 2.43rem">' +
          '<p style="text-align:right; font-size: 7px;">' +
          i +
          " / " +
          Math.ceil(newData.length / 26) +
          "</p>" +
          '<p style="text-align:center; font-weight: bold; font-size: 1.2rem; margin: 0; margin-top: -1rem">' +
          "Sonar Pos" +
          "</p>" +
          '<p style="text-align:center; margin: 0; font-size: 10px">' +
          "Items List" +
          "</p>" +
          "</div>";
      }

      // Printing table body
      content +=
        '<table style="font-size: 7px; margin-left: 1rem; margin-top: 1rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 7px;">No</th>' +
        '<th style="padding: 7px; ">Name</th>';

      if (!hiddenColumns.includes("CategoryFullPath")) {
        content += '<th style="padding: 7px;">Category</th>';
      }

      checkUserPermission("show-cost-price") &&
        !hiddenColumns.includes("CostPrice") &&
        (content +=
          '<th style="padding: 7px; text-align: right;">Cost Price</th>');

      if (!hiddenColumns.includes("SellingPrice")) {
        content +=
          '<th style="padding: 7px; text-align: right;">Sell Price</th>';
      }

      if (!hiddenColumns.includes("Quantity")) {
        content += '<th style="padding: 7px; text-align: right;">Quantity</th>';
      }

      content += "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex
      for (let index = startIndex; index <= endIndex; index++) {
        if (index < newData.length) {
          content +=
            "<tr>" +
            // First row
            "<tr>" +
            '<td style="font-size: 7px; padding: 2px 7px 0px 7px;">' +
            (index + 1) +
            "</td>" +
            '<td colspan="6" style="font-size: 7px; padding: 0px 7px; z-index: 1; width: 560px">' +
            '<p style="font-size: 7px; margin: 0">' +
            newData[index].Name +
            "</p>" +
            "</td>" +
            "</tr>" +
            // Second row
            "<tr>" +
            '<td style="font-size: 7px; padding: 2px 7px;"></td>' +
            '<td style="font-size: 7px; padding: 2px 7px; font-weight: bold;">UPC/EAN/ISBN: ' +
            newData[index].Itemnumber +
            "</td>";

          if (!hiddenColumns.includes("CategoryFullPath")) {
            content +=
              '<td style="font-size: 7px; padding: 2px 7px;">' +
              newData[index].Categoryfullpath +
              "</td>";
          }

          checkUserPermission("show-cost-price") &&
            !hiddenColumns.includes("CostPrice") &&
            (content +=
              '<td style="font-size: 7px; padding: 2px 7px; text-align: right;">' +
              Number(newData[index].Costprice).toFixed(2) +
              "</td>");

          if (!hiddenColumns.includes("SellingPrice")) {
            content +=
              '<td style="font-size: 7px; padding: 2px 7px; text-align: right;">' +
              Number(newData[index].Unitprice).toFixed(2) +
              "</td>";
          }

          if (!hiddenColumns.includes("Quantity")) {
            content +=
              '<td style="font-size: 7px; padding: 2px 7px; text-align: right;">' +
              Number(newData[index].Quantity).toFixed(2) +
              "</td>";
          }

          content += "</tr></tr>";
        }
      }

      content += "</tbody>";
      content += "</table>";

      startIndex = endIndex + 1;
      endIndex = Math.min(startIndex + 25, newData.length - 1);
    }

    // Printing page
    doc.html(content, {
      callback: function (pdf) {
        pdf.output("dataurlnewwindow");
        setLoading(false);
      },
    });
  };

  const handleDateFilterCancel = () => {
    setShowDateFilterModal(false);
  };

  const handleDateFilterConfirm = () => {
    console.log("api call delete");
    const deleteRequestParam = localStorage.getItem("DeleteRequestParam");
    console.log("deleteRequestParam: 12", deleteRequestParam);
    const deleteApiUrl = `${config.itemsBaseUrl}/items/deletemultiple`;
    // console.log("deleteApiUrl: ", deleteApiUrl);
    axios
      .post(`${deleteApiUrl}`, deleteRequestParam, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then(() => {
        toastSuccess(DELETE_MESSAGE);
        // window.location.reload();
        window.location.href = window.location.href;
      });

    setShowDateFilterModal(false);
  };

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row" style={{ marginTop: "5px" }}>
              <h3 className="page-title">Inventory: Items</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">Items List</li>
              </ul>
            </div>
          </div>
          <div className="d-flex w-100">
            <div style={{ width: "90%", display: "flex", marginTop: "2px" }}>
              {/* <div
                style={{ padding: "5px" }}
              >
                <input
                  type="search"
                  placeholder="Search..."
                  // className="form-control-sm w-100 mt-1"
                  className="search-btn form-control form-control-sm w-100 pull-right"
                  onChange={ChangeFilterText}
                  value={searchtext}
                />
              </div> */}

              <div
                className="col-md-4 col-sm me-2 mt-1"
                style={{ height: "32px" }}
              >
                <Select
                  backspaceRemovesValue={false}
                  controlShouldRenderValue={true}
                  hideSelectedOptions={true}
                  isClearable={true}
                  // onChange={setselectedCategory}
                  onChange={(e) => handleCategoryChanged(e)}
                  options={Catagories}
                  placeholder="Categories"
                  styles={selectStyles}
                  value={
                    Catagories.find(
                      (option) => option?.value === selectedCategory?.value
                    ) || ""
                  }
                  id="Category"
                  name="Category"
                  className="w-100 custom-search-select"
                />
              </div>
            </div>
            <div className="btn-group ms-2 mt-1 dropdown">
              <div className="me-2">
                {checkUserPermission(PERMISSION_ADD) ? (
                  <Link
                    to="/manage-items"
                    className="btn btn-primary btn-sm pull-right"
                    style={{ width: "max-content" }}
                  >
                    <i className="fa fa-plus me-2 lg"></i>
                    New Items
                  </Link>
                ) : (
                  ""
                )}
              </div>

              <div className="btn-group-sm  pull-right ms-2">
                <button
                  type="button"
                  className="btn btn-outline-dark custom-bg-dark-button-color d-none"
                >
                  More
                </button>
                <button
                  type="button"
                  className="btn btn-outline-dark custom-bg-dark-button-color dropdown-toggle me-1"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  style={{ borderRadius: "5px" }}
                >
                  More &nbsp;
                  {/* <span className="sr-only">Toggle Dropdown</span> */}
                </button>
                <div className="dropdown-menu">
                  {/* <li><Link class="dropdown-item" to="/customer-intake-form">Customer Intake Form</Link></li> */}
                  {true ? (
                    // checkUserPermission(PERMISSION_EXCEL_IMPORT)
                    <li>
                      <Link class="dropdown-item" to="/item-count-invetory">
                        Count Inventory
                      </Link>
                    </li>
                  ) : (
                    ""
                  )}
                  {checkUserPermission(PERMISSION_EXCEL_IMPORT) ? (
                    <li>
                      <Link className="dropdown-item" to="/import-items">
                        Excel Import
                      </Link>
                    </li>
                  ) : (
                    ""
                  )}
                  {checkUserPermission(PERMISSION_EXCEL_EXPORT) ? (
                    <li>
                      <Link
                        className="dropdown-item"
                        onClick={handleExcelExport}
                      >
                        Excel Export
                      </Link>
                    </li>
                  ) : (
                    ""
                  )}
                  {checkUserPermission(PERMISSION_MANAGE_DELETED_ITEMS) ? (
                    <li>
                      <Link className="dropdown-item" to="/deleted-items">
                        Manage Deleted Items
                      </Link>
                    </li>
                  ) : (
                    ""
                  )}
                  {checkUserPermission(PERMISSION_CLEANUP_OLD_ITEMS) ? (
                    <li>
                      <Link
                        to="#"
                        title="Cleanup old Customers"
                        className="dropdown-item"
                        data-bs-toggle="modal"
                        data-bs-target="#CleanupConfirmationModal"
                      >
                        Cleanup old Items
                      </Link>
                    </li>
                  ) : (
                    ""
                  )}
                  {checkUserPermission(
                    PERMISSION_CUSTOM_FIELD_CONFIGURATION
                  ) ? (
                    <li>
                      <Link className="dropdown-item" to="/items-custom-fields">
                        Items Custom Fields
                      </Link>
                    </li>
                  ) : (
                    ""
                  )}
                  {/* <li><Link to="/custom-field-configuration" title="Custom Field Configuration" className="dropdown-item" >Custom Field Configuration</Link></li> */}
                </div>
              </div>
              <div className="ml-1">
                <button
                  className="btn btn-primary btn-sm"
                  onClick={() => handlePrint("", "alldata")}
                >
                  {/* <button className="btn btn-primary btn-sm" onClick={handlePrint}> */}
                  Print
                </button>
              </div>
              {/* <div className="btn-group-sm pull-right ms-2 dropdown">
                <button
                  type="button"
                  className="btn btn-outline-primary dropdown-toggle"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  style={{ borderRadius: "5px" }}
                >
                  <i className="fa fa-cog"></i> &nbsp;
                </button>
                {/* <div className="dropdown-menu" style={{ "max-height": "300px", "overflow": "auto" }}>
                  {columns?.map((column) => column.name.replace(/\s+|-|\/|#/g, "") !== "Action" ? (
                    <div key={column.name.replace(/\s+|-|\/|#/g, "")} className="form-check ms-2 mt-1">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id={`checkbox-${column.name.replace(/\s+|-|\/|#/g, "")}`}
                        value={column.name.replace(/\s+|-|\/|#/g, "")}
                        checked={!hiddenColumns.includes(column.name.replace(/\s+|-|\/|#/g, ""))} // check all checkboxes which are not include in hiddenColumns
                        onChange={() =>
                          handleCheckboxChange(column.name.replace(/\s+|-|\/|#/g, ""))
                        }
                      />
                      <label className="form-check-label" htmlFor={`checkbox-${column.name.replace(/\s+|-|\/|#/g, "")}`}>
                        {column.name}
                      </label>
                    </div>
                  ) : (
                    ""
                  )
                  )}
                </div> */}
            </div>
          </div>
          <div className="row mt-1">
            <div className="col-lg-12 col-md-6 col-sm-12">
              <div className="d-flex flex-wrap">
                {/* <div className="p-1">
                  <input
                    type="search"
                    placeholder="Search..."
                    className="search-btn form-control form-control-sm  w-100 pull-right"
                    onChange={ChangeFilterText}
                    value={searchtext}
                  />
                </div> */}

                {/* <div style={{ width: "12%" }}>
                <Select
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    onChange={(event)=>handleFieldChange(event)}
                    options={fieldOption}
                    placeholder="Select a field"
                    styles={selectStyles}
                    value={ fieldOption?.find((el)=>
                      el.value == field
                    )}
                    id="Field"
                    name="Field"
                    className="w-100"
                  />
                  </div> */}

                {/* <div className="col-md-2 col-sm-2">
                  <Select
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    onChange={setselectedCategory}
                    options={ParentCategoryOption}
                    placeholder="Select a Category"
                    styles={selectStyles}
                    value={
                      ParentCategoryOption.find(
                        (option) =>
                          option?.value === selectedCategory
                      ) || ""
                    }
                    id="Category"
                    name="Category"
                    className="w-100"
                  />
                </div> */}

                <div className="p-1 d-none">
                  <Select
                    defaultValue={quickBookOptions}
                    onChange={(event) => {
                      handleQuickBookChange("ExcelExport", event);
                    }}
                    options={options}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    styles={selectStyles}
                    id="ExcelExport"
                    name="ExcelExport"
                  />
                </div>

                {quickBookOptions?.value == 2 && (
                  <>
                    <div className="p-1 pt-0">
                      Custom Start Date:
                      <input
                        type="date"
                        className="form-control"
                        id="StartDate"
                        name="StartDate"
                        onChange={(event) =>
                          handleChangeCustomStartingDate(event)
                        }
                      />
                    </div>
                    <div className="p-1 pt-0">
                      Custom End Date:
                      <input
                        type="date"
                        className="form-control"
                        id="EndDate"
                        name="EndDate"
                        onChange={(event) =>
                          handleChangeCustomEndingDate(event)
                        }
                      />
                    </div>
                  </>
                )}
                {showSearchBar === 2 ? (
                  <div className="p-1">
                    <button
                      className="btn btn-dark"
                      onClick={() => handleSearchAccordingToDate()}
                      disabled={loading === true}
                    >
                      Search
                    </button>
                  </div>
                ) : (
                  ""
                )}
                <div className="p-1 d-none">
                  <button
                    className="btn btn-primary"
                    onClick={() => handleQuickBookDownload()}
                  >
                    Export to excel for quickbook
                  </button>
                </div>
                {quickBookOptions?.value !== 2 && (
                  <>
                    <div className="p-1 "></div>
                  </>
                )}
                {/* <div className="p-1">
                  <button className="btn btn-dark btn-sm" onClick={handlePrint}>
                    Print
                  </button>
                </div> */}
              </div>
            </div>
          </div>
          <div>
            <MaterialReactTable
              columns={columns}
              data={data}
              enableColumnResizing
              enableRowActions
              renderRowActionMenuItems={({ row }) => [
                <MenuItem
                  key="edit"
                  onClick={() => navigate(`/manage-Items/${row.original.ID}`)}
                >
                  Edit
                </MenuItem>,
                <MenuItem
                  className="confirm-text"
                  to="#"
                  // key="delete"
                  title="Delete"
                  // data-bs-toggle="modal"
                  // data-bs-target="#DeleteConfirmationModal"
                  onClick={() => handleDeletePopup(row.original.ID)}
                >
                  Delete
                </MenuItem>,
              ]}
              enableGrouping
              enableStickyHeader
              enableStickyFooter
              enableRowSelection
              enableColumnOrdering
              initialState={{
                density: "compact",
                expanded: true, //expand all groups by default
                // grouping: [""], //an array of columns to group by by default (can be multiple)
                pagination: { pageIndex: 0, pageSize: 25 },
                sorting: [{ id: "state", desc: false }], //sort by state by default
              }}
              // muiToolbarAlertBannerChipProps={{ color: "primary" }}
              // muiTableContainerProps={{ sx: { maxHeight: 700 } }}
              muiTablePaginationProps={{
                rowsPerPageOptions: [25, 50, 100, 300, 500],
              }}
              muiTableContainerProps={{ sx: { maxHeight: "fit-content" } }}
              // manualFiltering
              manualPagination
              manualSorting
              muiToolbarAlertBannerProps={
                isError
                  ? {
                      color: "error",
                      children: "Error loading data",
                    }
                  : undefined
              }
              // onColumnFiltersChange={setColumnFilters}
              onGlobalFilterChange={setGlobalFilter}
              onPaginationChange={setPagination}
              onSortingChange={setSorting}
              rowCount={totalRows}
              state={{
                // columnFilters,
                // globalFilter,
                isLoading,
                pagination,
                showAlertBanner: isError,
                showProgressBars: isRefetching,
                sorting,
              }}
              renderTopToolbarCustomActions={({ table }) => (
                <Box
                  sx={{
                    display: "flex",
                    gap: "1rem",
                    p: "0.5rem",
                    flexWrap: "wrap",
                  }}
                >
                  <Button
                    size="small"
                    disabled={
                      !table.getIsSomeRowsSelected() &&
                      !table.getIsAllRowsSelected()
                    }
                    //only export selected rows
                    onClick={() =>
                      handleDeletePopup(
                        "",
                        table.getSelectedRowModel().rows,
                        "multipleRowInactive"
                      )
                    }
                    // startIcon={<FileDownloadIcon />}
                    variant="contained"
                  >
                    Delete Selected
                  </Button>
                  <NavLink to={"/customer-barcode-label"}>
                    <Button
                      size="small"
                      disabled={
                        !table.getIsSomeRowsSelected() &&
                        !table.getIsAllRowsSelected()
                      }
                      //only export selected rows
                      onClick={() =>
                        handlebarcode(
                          "",
                          table.getSelectedRowModel().rows,
                          "multipleRowInactive"
                        )
                      }
                      // startIcon={<FileDownloadIcon />}
                      variant="contained"
                    >
                      Barcode Labels
                    </Button>
                  </NavLink>
                  {/* <Button
                    size="small"
                    onClick={() =>
                      // setPagination({ ...pagination, pageSize: totalRows })
                      setPagination({
                        ...pagination,
                        // pageIndex: 0,
                        pageSize: totalRows,
                      })
                    }
                    variant="contained"
                  >
                    Get All Data
                  </Button> */}
                </Box>
              )}
            />
          </div>
        </div>

        {/* <div class="d-flex flex-row">
            <div class="p-3 mt-3 col-md-2">
              <Select
                defaultValue={quickBookOptions}
                onChange={(event) => {
                  handleQuickBookChange("ExcelExport", event);
                }}
                className=""
                options={options}
                backspaceRemovesValue={false}
                controlShouldRenderValue={true}
                isClearable={true}
                // styles={selectStyles}
                id="ExcelExport"
                name="ExcelExport"
              />
            </div>
            {quickBookOptions.value == 2 && (
              <>
                <div class="p-3 col-md-2">
                  tartStart Date:
                  <input
                    type="date"
                    className="form-control"
                    id="StartDate"
                    name="StartDate"
                    onChange={(event) => handleChangeCustomStartingDate(event)}
                  />
                </div>
                <div class="p-3 col-md-2">
                  Custom End Date:
                  <input
                    type="date"
                    className="form-control"
                    id="EndDate"
                    name="EndDate"
                    onChange={(event) => handleChangeCustomEndingDate(event)}
                  />
                </div>
              </>
            )}
            <div class="p-3 col-md-4 mt-3">
              <button
                className="btn btn-primary"
                onClick={() => handleQuickBookDownload()}
              >
                Export to excel for quickbook
              </button>
            </div>
          </div>

          <div className="row flex-row-reverse mt-2">
            <div className="col-lg-3 col-md-6 col-sm-12 mb-2">
              <input
                type="search"
                placeholder="Search..."
                className="search-btn form-control form-control-sm w-50 pull-right"
                onChange={ChangeFilterText}
                value={searchtext}
              /> */}
        {/* <Input.Search placeholder="Search..." className="search-btn form-control form-control-sm" onChange={ChangeFilterText} /> */}
        {/* </div>
          </div> */}

        {/* Items list */}
        {/* <div className="card">
            <div className="card-body" style={{ padding: "10px 20px 0 20px" }} >
              <div className="table-responsive">
                <DataTable
                  title="Items List"
                  //   columns={columns}
                  data={data}
                  columns={columns}
                  // progressPending={loading}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationDefaultPage={currentPage}
                  onChangeRowsPerPage={(e) => {
                    handlePerRowsChange(1, e);
                  }}
                  onChangePage={handlePageChange}
                  highlightOnHover
                  striped
                  responsive
                  paginationRowsPerPageOptions={[25, 50, 100, 500]}
                  fixedHeader
                  fixedHeaderScrollHeight="600px"
                  persistTableHead
                  sortServer
                  onSort={handleSort}
                  selectableRows
                  contextActions={contextActions}
                  onSelectedRowsChange={handleRowSelected}
                  clearSelectedRows={toggleCleared}
                  paginationPerPage={perPageSize}
                />
              </div>
            </div>
          </div> */}
        {/* <div>
          <MaterialReactTable
            columns={columns}
            data={data}
            enableColumnResizing
            enableRowActions
            renderRowActionMenuItems={({ row }) =>
              [
                (<MenuItem key="edit" onClick={() => navigate(`/manage-Items/${row.original.ID}`)}>
                  Edit
                </MenuItem>),
                <MenuItem
                  className="confirm-text"
                  to="#"
                  // key="delete"
                  title="Delete"
                  data-bs-toggle="modal"
                  data-bs-target="#DeleteConfirmationModal"
                  onClick={() => handleDeletePopup(row.original.ID)}
                >
                  Delete
                </MenuItem>,
              ]
            }

            enableGrouping
            enableStickyHeader
            enableStickyFooter
            enableRowSelection
            enableColumnOrdering
            initialState={{
              density: "compact",
              expanded: true, //expand all groups by default
              // grouping: [""], //an array of columns to group by by default (can be multiple)
              pagination: { pageIndex: 0, pageSize: 25 },
              sorting: [{ id: "state", desc: false }], //sort by state by default
            }}
            // muiToolbarAlertBannerChipProps={{ color: "primary" }}
            // muiTableContainerProps={{ sx: { maxHeight: 700 } }}
            muiTablePaginationProps={{
              rowsPerPageOptions: [25, 50, 100, 300, 500],
            }}
            muiTableContainerProps={{ sx: { maxHeight: 'fit-content' } }}
            // manualFiltering
            manualPagination
            manualSorting
            muiToolbarAlertBannerProps={
              isError
                ? {
                  color: 'error',
                  children: 'Error loading data',
                }
                : undefined
            }
            // onColumnFiltersChange={setColumnFilters}
            onGlobalFilterChange={setGlobalFilter}
            onPaginationChange={setPagination}
            onSortingChange={setSorting}
            rowCount={totalRows}
            state={{
              // columnFilters,
              globalFilter,
              isLoading,
              pagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              sorting,
            }}
          />
        </div> */}
      </div>
      {/* </div> */}

      {/* Delete Model  */}
      <DeleteConfirmationModal
        deleteApiUrl={`${config.itemsBaseUrl}/items/deletemultiple`}
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
      />
      {/* Cleanup old items */}
      <CleanupConfirmationModal
        CleanupConformationApiUrl={`${config.itemsBaseUrl}/items/deletepermanantely`}
      />
      <ItemsDetailsModal id={itemsDetailsDataId} />
    </>
  );
};

export default Items;
